<template>
    <ion-item-sliding
        ref="slidingItem"
        class="card-border"
        :disabled="disabled"
        @click="closeItem($event)"
    >
        <ion-item-options
            side="start"
            v-if="$slots['options-start']"
            class="button-options options-start"
        >
            <slot name="options-start"/>
        </ion-item-options>

        <slot name="item">
            <ion-item
                class="no-dimensions max-height native-max"
                :class="{'ion-activatable card-ripple-parent': itemButton}"
                lines="none"
            >
                <slot/>
                <ion-ripple-effect v-if="itemButton && !isOpen"/>
            </ion-item>

            <div class="reduced-amount">
                <slot name="reduced-amount"></slot>
            </div>
        </slot>

        <ion-item-options
            side="end"
            v-if="$slots['options-end']"
            class="button-options options-end"
        >
            <slot name="options-end"/>
        </ion-item-options>
    </ion-item-sliding>
</template>

<script setup lang="ts">
import { IonItem, IonItemOptions, IonItemSliding, IonRippleEffect, useKeyboard } from "@ionic/vue";
import { ref } from "vue";

import { ButtonSlidingProps } from "@/types/props";

defineProps<ButtonSlidingProps>()

const { isOpen } = useKeyboard()

const slidingItem = ref()

const closeItem = async (event: any): Promise<void> => {
    if (event.target.tagName !== 'ION-ITEM-OPTIONS') return;
    slidingItem.value.$el.close()
}

defineExpose({
    slidingItem,
    open: (direction?: 'start' | 'end') => slidingItem.value.$el.open(direction),
    close: () => slidingItem.value.$el.close()
})
</script>


<style scoped>
.card-border {
    position: relative;
}

.no-dimensions {
    --padding-start: 0;
    --inner-padding-end: 0;
    --inner-border-width: 0;
    --background: transparent;
}

.options-end {
    border-radius: 0 16px 16px 0;
}

.options-start {
    border-radius: 16px 0 0 16px;
}

.button-options {
    border-bottom-width: 0 !important;
}

.native-max::part(native) {
    height: 100%;
}

.reduced-amount {
    position: absolute;
    top: 16px;
    right: 12px;
    z-index: 9;
}
</style>

<style>
.button-options > * {
    isolation: isolate;
    position: relative;
    border-radius: inherit;
}

.item-options-end ion-item-option:first-child::after {
    content: "";
    background: inherit;
    min-width: 16px;
    min-height: 100%;
    position: absolute;
    left: -16px;
}

.item-options-start ion-item-option:last-child::after {
    content: "";
    background: inherit;
    min-width: 16px;
    min-height: 100%;
    position: absolute;
    right: -16px;
}
</style>
